function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.99244 51.9031H37.9846C38.7284 51.9031 39.419 51.4914 39.751 50.8273C40.0964 50.1633 40.0299 49.3664 39.6049 48.7555L30.4674 35.9656H34.0003C34.7307 35.9656 35.4081 35.5672 35.7534 34.9164C36.0987 34.2656 36.0588 33.482 35.6604 32.8711L27.094 20.0281H30.0159C30.7729 20.0281 31.4635 19.6031 31.7956 18.9258C32.1276 18.2484 32.0612 17.4383 31.6096 16.8406L21.6487 0.770306C20.8917 -0.239069 19.2182 -0.239069 18.4612 0.770306L8.50025 16.8406C8.04869 17.4383 7.969 18.2484 8.31432 18.9258C8.64635 19.6031 9.33697 20.0281 10.094 20.0281H13.0159L4.44947 32.8711C4.03775 33.482 3.99791 34.2656 4.3565 34.9164C4.7151 35.5672 5.37916 35.9656 6.10963 35.9656H9.64244L0.372128 48.7555C-0.0661535 49.3664 -0.119279 50.1633 0.226034 50.8273C0.558065 51.4914 1.24869 51.9031 1.99244 51.9031Z",
  fill: "url(#paint0_linear_107_12)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M66.0078 63.989H51.9297V55.8875H43.9609V63.989H24.0391V55.8875H16.0703V63.989H1.99219C0.889844 63.989 0 64.8789 0 65.9812C0 67.0836 0.889844 67.9734 1.99219 67.9734H66.0078C67.1102 67.9734 68 67.0836 68 65.9812C68 64.8789 67.1102 63.989 66.0078 63.989Z",
  fill: "url(#paint1_linear_107_12)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9845 20.0281H40.9064L36.3908 26.8016L38.9673 30.6664C40.1892 32.4992 40.3088 34.85 39.2595 36.8023C38.808 37.6391 38.1838 38.343 37.4267 38.8742L42.8322 46.4445C43.9877 48.0516 44.2002 50.0836 43.5494 51.9031H65.9947C66.7384 51.9031 67.4291 51.4914 67.7611 50.8273C68.1064 50.1633 68.04 49.3664 67.615 48.7555L58.3447 35.9656H61.8908C62.6212 35.9656 63.2986 35.5672 63.6439 34.9164C63.9892 34.2656 63.9494 33.482 63.5509 32.8711L54.9845 20.0281H57.9064C58.6634 20.0281 59.3541 19.6031 59.6861 18.9258C60.0181 18.2484 59.9517 17.4383 59.5002 16.8406L49.5392 0.770306C48.7822 -0.239069 47.1088 -0.239069 46.3517 0.770306L36.3908 16.8406C35.9392 17.4383 35.8595 18.2484 36.2049 18.9258C36.5369 19.6031 37.2275 20.0281 37.9845 20.0281Z",
  fill: "url(#paint2_linear_107_12)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_107_12",
  x1: 0.265878,
  y1: 25.9648,
  x2: 67.837,
  y2: 25.9648,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A77C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B6DE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_107_12",
  x1: 0.265625,
  y1: 61.9347,
  x2: 67.8368,
  y2: 61.9347,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A77C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B6DE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_107_12",
  x1: 0.265804,
  y1: 25.9647,
  x2: 67.8369,
  y2: 25.9647,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A77C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B6DE"
})));

var SvgPine1 = function SvgPine1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPine1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pine1.2b2f2a2f.svg";
export { ForwardRef as ReactComponent };